import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { Observable } from 'rxjs';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';
import { QuizService, QuizReviewState } from '../data-access/quiz.service';
import { CodecraftQuizListPageComponent } from '../features/list-page.component';
import { CodecraftQuizReviewPageWrapperComponent } from './review-page-wrapper.component';

@Component({
  standalone: true,
  selector: 'codecraft-quiz-review',
  template: `
    <div
      *ngIf="uid && quizReviewState$ | async as quizReviewState; else loading"
    >
      <div [ngSwitch]="quizReviewState.component">
        <codecraft-quiz-list-page
          *ngSwitchCase="'review-table'"
          [uid]="uid"
        ></codecraft-quiz-list-page>
        <codecraft-quiz-review-page-wrapper
          *ngSwitchCase="'review'"
        ></codecraft-quiz-review-page-wrapper>
        <div *ngSwitchCase="'error'">
          <p class="text-danger">{{ quizReviewState.error }}</p>
        </div>
        <div *ngSwitchDefault>
          <p>Unknown review state: {{ quizReviewState.component }}</p>
        </div>
      </div>
    </div>
    <ng-template #loading>
      <p class="h1">Review Loading</p>
      <hr />
      <codecraft-loading-spinner></codecraft-loading-spinner>
    </ng-template>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  imports: [
    NgIf,
    AsyncPipe,
    NgSwitch,
    NgSwitchCase,
    CodecraftQuizListPageComponent,
    CodecraftQuizReviewPageWrapperComponent,
    LoadingSpinnerComponent,
  ],
})
export class CodecraftQuizReviewComponent implements OnInit {
  @Input() uid!: string;

  quizReviewState$!: Observable<QuizReviewState>;
  constructor(private quizService: QuizService) {}

  async ngOnInit(): Promise<void> {
    // Get token from cookie named `session`
    const idToken = document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith('session='))
      ?.split('=')[1];

    if (idToken) {
      try {
        const decoded: any = jwtDecode(idToken);
        this.uid = decoded.user_id || decoded.uid;
      } catch (e) {
        this.quizService.setQuizReviewState({
          component: 'error',
          error: 'Invalid JWT token',
        });
        return;
      }
    }

    if (!this.uid) {
      this.quizService.setQuizReviewState({
        component: 'error',
        error: 'Missing uid',
      });
      return;
    }
    try {
      await this.quizService.initializeReviewTable(this.uid);
      this.quizReviewState$ = this.quizService.getQuizReviewState$();
    } catch (error) {
      console.error('Init error:', error);
      this.quizService.setQuizReviewState({
        component: 'error',
        error: 'Quiz review component init error: ' + error,
      });
    }
  }
}
